import React from "react";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";

const StandardCakeSizes = ({ formData, setFormData, sizeOptions }) => {
  const handleChange = (value) => {
    const selectedSizes = sizeOptions.filter((s) => value.includes(s._id));
    setFormData((prev) => ({
      ...prev,
      sizes: selectedSizes,
    }));
  };

  return (
    <>
      <Typography sx={{ mt: 2, mb: 1 }}>Sizes</Typography>
      <FormControl fullWidth>
        <InputLabel>Select Sizes</InputLabel>
        <Select
          multiple
          value={formData.sizes.map((s) => s._id)}
          onChange={(e) => handleChange(e.target.value)}
          renderValue={(selected) =>
            selected
              .map((id) => {
                const size = sizeOptions.find((s) => s._id === id);
                return size
                  ? `${size.name} ($${size.price.toFixed(2)} CAD)`
                  : "";
              })
              .join(", ")
          }
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 280,
                width: "auto",
                padding: 0,
              },
            },
          }}>
          {sizeOptions.map((size) => (
            <MenuItem key={size._id} value={size._id} sx={{ py: 0.5, px: 1.5 }}>
              <Checkbox
                checked={formData.sizes.some((s) => s._id === size._id)}
                sx={{ padding: 0.5 }}
              />
              <ListItemText
                primary={`${size.name} ($${size.price.toFixed(2)} CAD)`}
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default StandardCakeSizes;
